import axios from 'axios';
import { Envelope } from '../interfaces/envelope';
import { Area } from '../interfaces/areas';

async function getAreas(): Promise<Area[]> {
	try {
		const response = await axios.get<Envelope<Area[]>>(`areas`);
		return response.data.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response!.data;
		}
		throw error;
	}
}

export const areas = {
	getAreas,
};
